
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const EmtpyState: React.FC = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                color: "text.secondary",
                py: 4,
            }}
        >
            <InfoOutlinedIcon sx={{ fontSize: 48, mb: 1, color: "primary.main" }} />
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
                No entries found
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
                Try adjusting your filters or upload new data.
            </Typography>
        </Box>
    );
}